import React, { useState } from 'react';
import axios from 'axios';
import LogoBazze from '../../../assets/bazze-logo-v2.svg';
import EventPhoto from '../../../assets/expo-revestir-2026.jpeg';
import './style.css';

const API_URL = 'https://bbllrr.hospedagemelastica.com.br/card/public/site-lead';
const API_KEY = process.env.REACT_APP_SITE_LEAD_API_KEY || '';

const VENDEDORES = [
  { id: 78,  nome: 'ALEXANDRE NICOLA' },
  { id: 91,  nome: 'BRUNO BERTOLUCCI' },
  { id: 164, nome: 'CRISTIANO FAVERSANI' },
  { id: 146, nome: 'DANIEL GRACIANO' },
  { id: 192, nome: 'DIEGO CAZULKE' },
  { id: 182, nome: 'EDUARDO CUNHA' },
  { id: 120, nome: 'EDUARDO MATOS' },
  { id: 86,  nome: 'FABIO CUNHA - LITORAL' },
  { id: 81,  nome: 'FABIO SOUZA' },
  { id: 144, nome: 'FELIPE HEILMANN' },
  { id: 224, nome: 'FERNANDO HENDGES' },
  { id: 159, nome: 'GUILHERME POZZA' },
  { id: 271, nome: 'JENNIFER MORAES' },
  { id: 166, nome: 'LEANDRO CORREA' },
  { id: 201, nome: 'LUCAS MATOS' },
  { id: 128, nome: 'LUIZE SPOLAVORI' },
  { id: 179, nome: 'LUIZ FERNANDO' },
  { id: 79,  nome: 'MAICO SARTORI' },
  { id: 97,  nome: 'MARCO GUIDI' },
  { id: 169, nome: 'MARIA CAROLINA SOUZA' },
  { id: 270, nome: 'MARIA EDUARDA SOUZA' },
  { id: 155, nome: 'MICHEL MAFRA' },
  { id: 88,  nome: 'NATALIA - ESQUADRIAS' },
  { id: 80,  nome: 'PAULO COLETTI' },
  { id: 249, nome: 'RAFAEL MAYER' },
  { id: 135, nome: 'RAFAEL SARTORI' },
  { id: 165, nome: 'ROMEU SCHNEIDER' },
  { id: 183, nome: 'TATIANE FRAGA' },
  { id: 266, nome: 'VITÓRIA' },
].sort((a, b) => a.nome.localeCompare(b.nome));

const IDENTIFICACOES = [
  'Consumidor Final',
  'Arquiteto',
  'Construtor',
];

const ESTADOS = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO',
  'MA','MT','MS','MG','PA','PB','PR','PE','PI',
  'RJ','RN','RS','RO','RR','SC','SP','SE','TO',
];

export default function ExpoRevestirPage() {
  const [form, setForm] = useState({
    name: '', email: '', fone: '', identificacao: '',
    state: '', city: '', creator_id: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim())   e.name = true;
    if (!form.email.trim())  e.email = true;
    if (!form.fone.trim())   e.fone = true;
    if (!form.identificacao) e.identificacao = true;
    if (!form.state)         e.state = true;
    if (!form.city.trim())   e.city = true;
    if (!form.creator_id)    e.creator_id = true;
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

    setLoading(true);
    try {
      const v = VENDEDORES.find(v => String(v.id) === form.creator_id);
      const creatorLabel = v ? `${v.nome} - ${v.id}` : form.creator_id;

      await axios.post(API_URL, {
        empresa_id: 2, column_id: 29, origem_id: 16,
        creator_id: creatorLabel,
        name: form.name.trim(), email: form.email.trim(),
        fone: form.fone.trim(), city: form.city.trim(),
        state: form.state,
      }, { headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY } });
      setSuccess(true);
    } catch { setErrors({ submit: true }); }
    finally { setLoading(false); }
  };

  const inputCls = (field) =>
    `exrv-input ${errors[field] ? 'exrv-input--error' : ''}`;

  const selectCls = (field) =>
    `exrv-select ${errors[field] ? 'exrv-input--error' : ''}`;

  if (success) {
    return (
      <div className="exrv-root">
        <header className="exrv-header">
          <img src={LogoBazze} alt="Bazze" className="exrv-logo" />
        </header>
        <div className="exrv-success-wrap">
          <div className="exrv-success-icon">&#10003;</div>
          <h2 className="exrv-success-title">Recebemos seu contato!</h2>
          <p className="exrv-success-text">
            Nossa equipe entrará em contato em breve.<br />Nos vemos na Expo Revestir!
          </p>
        </div>
        <footer className="exrv-footer">
          <span>Todos os direitos reservados @ 2026 Bazze</span>
        </footer>
      </div>
    );
  }

  return (
    <div className="exrv-root">
      <header className="exrv-header">
        <img src={LogoBazze} alt="Bazze" className="exrv-logo" />
      </header>

      <div className="exrv-body">
        {/* ── Left column: text + photo ── */}
        <div className="exrv-left">
          <div className="exrv-text">
            <h1 className="exrv-title">Bazze na Expo Revestir 2026</h1>
            <div className="exrv-divider-wrap">
              <div className="exrv-divider" />
            </div>
            <p className="exrv-desc">
              Convidamos você a conversar com nossa equipe no Estande P71 e sair
              com propostas que irão elevar seu próximo projeto ao alto padrão.
            </p>
          </div>
          <div className="exrv-photo">
            <img src={EventPhoto} alt="Expo Revestir 2026" className="exrv-photo-img" />
          </div>
        </div>

        {/* ── Right column: form ── */}
        <div className="exrv-right">
          <form className="exrv-form" onSubmit={handleSubmit} noValidate>
            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Nome e sobrenome</label>
              <div className="exrv-field-input">
                <input type="text" name="name" value={form.name}
                  onChange={handleChange} className={inputCls('name')} />
                {errors.name && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>E-mail</label>
              <div className="exrv-field-input">
                <input type="email" name="email" value={form.email}
                  onChange={handleChange} className={inputCls('email')} />
                {errors.email && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Número de celular</label>
              <div className="exrv-field-input">
                <input type="tel" name="fone" value={form.fone}
                  onChange={handleChange} className={inputCls('fone')} />
                {errors.fone && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Como você se identifica?</label>
              <div className="exrv-field-input">
                <select name="identificacao" value={form.identificacao}
                  onChange={handleChange} className={selectCls('identificacao')}>
                  <option value=""></option>
                  {IDENTIFICACOES.map(i => <option key={i} value={i}>{i}</option>)}
                </select>
                {errors.identificacao && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Estado</label>
              <div className="exrv-field-input">
                <input type="text" name="state" value={form.state}
                  onChange={handleChange} className={inputCls('state')} />
                {errors.state && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Cidade</label>
              <div className="exrv-field-input">
                <input type="text" name="city" value={form.city}
                  onChange={handleChange} className={inputCls('city')} />
                {errors.city && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            <div className="exrv-field">
              <label className="exrv-label"><em className="exrv-req">*</em>Vendedor</label>
              <div className="exrv-field-input">
                <select name="creator_id" value={form.creator_id}
                  onChange={handleChange} className={selectCls('creator_id')}>
                  <option value=""></option>
                  {VENDEDORES.map(v => (
                    <option key={v.id} value={String(v.id)}>{v.nome}</option>
                  ))}
                </select>
                {errors.creator_id && <span className="exrv-err-icon" title="Campo obrigatório">&#9888;</span>}
              </div>
            </div>

            {errors.submit && (
              <p className="exrv-submit-err">Erro ao enviar. Tente novamente.</p>
            )}

            <button type="submit" className="exrv-btn" disabled={loading}>
              {loading ? 'Enviando...' : 'Quero meu kit de amostras'}
            </button>
          </form>
        </div>
      </div>

      <footer className="exrv-footer">
        <span>Todos os direitos reservados @ 2026 Bazze</span>
      </footer>
    </div>
  );
}
